import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Button from '@saucelabs/sl-component-buttons';
import { Modal } from '@saucelabs/sl-component-overlay';
import modalConnect from '@saucelabs/sl-container-modal';
import { NewRadioDropdown } from '@saucelabs/sl-component-form';

import Styles from './../../components/AssignmentModal.styles';

const name = 'assignTeamsToGroup';

class AssignTeamsToGroupModal extends Component {
  state = { chosenGroupId: null };

  shouldComponentUpdate(nextProps) {
    const { show } = this.props;
    return show !== nextProps.show || nextProps.show;
  }

  onGroupSelect = (id) => {
    this.setState({ chosenGroupId: id });
  }

  handleAutocomplete = (query) => {
    const { onAutocompleteGroups } = this.props;
    onAutocompleteGroups({ query });
  }

  cleanAndHide = () => {
    const { onHide } = this.props;

    this.cleanup();
    onHide();
  }

  submit(payload) {
    const { handleSubmit } = this.props;
    handleSubmit(payload).then(() => this.cleanAndHide());
  }

  cleanup() {
    this.setState({ chosenGroupId: null });
  }

  render() {
    const { groups, onTeamClick, selectedTeams, show, teams } = this.props;
    const { chosenGroupId } = this.state;

    const groupsToList = groups
      .map((group) => ({
        text: group.name,
        value: group.id,
      }))
      .toArray();

    return (
      <Modal
        onHide={this.cleanAndHide}
        show={show}
      >
        <Modal.Header>
          <Modal.Title>Line of Business Assignment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="label">
            {'Assign the following '}
            {selectedTeams.size}
            {' '}
            {selectedTeams.size === 1 ? 'team' : 'teams'}
          </h5>
          <div>
            {selectedTeams.map((teamId) => {
              const team = teams.get(teamId);
              return (
                <span
                  key={team.name}
                  className={Styles['item-chip']}
                  onClick={() => onTeamClick(team.id)}
                  role="presentation"
                >
                  <span>x</span>
                  {' '}
                  {team.name}
                </span>
              );
            })}
          </div>
          <br />
          <span className="label">
            {'To line of business: '}
            <span className={Styles['optional-label']}>(optional)</span>
          </span>
          <br />
          <NewRadioDropdown
            autocomplete="external"
            etiquette="Select line of business"
            input={{
              onChange: this.onGroupSelect,
            }}
            onAutocomplete={this.handleAutocomplete}
            options={groupsToList}
          />
          <div className={Styles['info-block']}>
            <p>
              New line of business assignments will replace current assignments!
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            category="default"
            material
            onClick={this.cleanAndHide}
            size="sm"
          >
            Cancel
          </Button>
          <Button
            category="action"
            material
            name="assign"
            onClick={() => this.submit({
              groupId: chosenGroupId,
              selectedTeams,
            })}
            size="sm"
          >
            Assign
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

AssignTeamsToGroupModal.propTypes = {
  groups: ImmutablePropTypes.list.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onAutocompleteGroups: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  onTeamClick: PropTypes.func.isRequired,
  selectedTeams: ImmutablePropTypes.set.isRequired,
  show: PropTypes.bool.isRequired,
  teams: ImmutablePropTypes.orderedMap.isRequired,
};

export default modalConnect(name, AssignTeamsToGroupModal);
export { name, AssignTeamsToGroupModal };
